import http from 'core/services/http';
import Config from 'core/config';
import isObject from 'lodash/isObject';

const toQueryString = (obj) => {
  const params = Object.keys(obj).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
  return params.length ? params.join('&') : '';
};

class StaffService {
  static getTcEventStaff(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/personnel`);
  }

  static getTcEventNonPersonnelStaff(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/nonpersonnel`);
  }

  static getAvailableTcStaff(tcEventId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEventId}/availablepersonnel${queryString}`);
  }

  static getTcNonPersonnelStaff(tcId) {
    return http.get(`${Config.apiUrl}/testcenter/${tcId}/nonpersonnel`);
  }

  static getInvitedEventStaff(tcEventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${tcEventId}/invitation`);
  }

  static notifyStaff(data) {
    return http.post(`${Config.apiUrl}/notifystaff`, data);
  }

  static getStaffInvitations() {
    return http.get(`${Config.apiUrl}/authuser/staffinvitations`);
  }

  static updateStaffInvitation(id, status) {
    return http.post(`${Config.apiUrl}/staffinvitation/${id}/${status}`);
  }

  static getTestCenterInvitations() {
    return http.get(`${Config.apiUrl}/authuser/testcenterinvitations`);
  }

  static updateTestCenterInvitation(id, status) {
    return http.post(`${Config.apiUrl}/testcenterinvitation/${id}/${status}`);
  }

  static assignEventStaff(data) {
    return http.post(`${Config.apiUrl}/testcentereventpersonnel`, data);
  }

  static assignEventNonPersonnelStaff(data) {
    return http.post(`${Config.apiUrl}/testcenterevent/nonpersonnel`, data);
  }

  static unAssignEventNonPersonnelStaff(data) {
    return http.delete(`${Config.apiUrl}/testcenterevent/nonpersonnel`, { data });
  }

  static updateEventStaff(data) {
    return http.put(`${Config.apiUrl}/testcentereventpersonnel`, data);
  }

  static unassignEventStaff(id) {
    return http.delete(`${Config.apiUrl}/testcentereventpersonnel/${id}`,);
  }

  static getTestCenterPersonnel(id) {
    return http.get(`${Config.apiUrl}/testcenter/${id}/personnel`);
  }

  static getInvitations(id) {
    return http.get(`${Config.apiUrl}/testcenter/${id}/invitation`);
  }

  static deleteTestCenterInvitation(id) {
    return http.delete(`${Config.apiUrl}/testcenterinvitation/${id}`);
  }

  static deletePersonnelInvitation(id) {
    return http.delete(`${Config.apiUrl}/testcenterpersonnel/${id}`);
  }

  static getPersonnelByEmail(email) {
    return http.get(`${Config.apiUrl}/personnelbyemail?email=${email}`);
  }

  static invitePersonnel(data) {
    return http.post(`${Config.apiUrl}/testcenterinvitation`, data);
  }

  static createTcNonPersonnel(testCenterId, data) {
    return http.post(`${Config.apiUrl}/testcenter/${testCenterId}/nonpersonnel`, data);
  }
}

export default StaffService;
